module.exports = __webpack_public_path__ + "img/courseArrange.e0ab4740.svg";